// =============== SCORM RUNTIME ===============
// SCORM 1.2 and 2004 support with graceful degradation

let scormAPI = null;

export function initSCORM() {
  try {
    scormAPI = window.API || window.API_1484_11 || null;
    if (scormAPI) {
      const result = scormAPI.LMSInitialize ? scormAPI.LMSInitialize('') : scormAPI.Initialize('');
      return result === 'true';
    }
  } catch (error) {
    console.warn('SCORM not available:', error.message);
  }
  return false;
}

export function setSCORMValue(key, value) {
  if (!scormAPI) return false;
  try {
    const result = scormAPI.LMSSetValue ? scormAPI.LMSSetValue(key, value) : scormAPI.SetValue(key, value);
    return result === 'true';
  } catch (error) {
    console.warn('SCORM SetValue failed:', error.message);
    return false;
  }
}

export function commitSCORM() {
  if (!scormAPI) return false;
  try {
    const result = scormAPI.LMSCommit ? scormAPI.LMSCommit('') : scormAPI.Commit('');
    return result === 'true';
  } catch (error) {
    console.warn('SCORM Commit failed:', error.message);
    return false;
  }
}

export function finishSCORM() {
  if (!scormAPI) return false;
  try {
    const result = scormAPI.LMSFinish ? scormAPI.LMSFinish('') : scormAPI.Terminate('');
    scormAPI = null;
    return result === 'true';
  } catch (error) {
    console.warn('SCORM Finish failed:', error.message);
    return false;
  }
}
